import { render, staticRenderFns } from "./UserParametrizacaoManage.vue?vue&type=template&id=8851675e&scoped=true"
import script from "./UserParametrizacaoManage.vue?vue&type=script&lang=js"
export * from "./UserParametrizacaoManage.vue?vue&type=script&lang=js"
import style0 from "./UserParametrizacaoManage.vue?vue&type=style&index=0&id=8851675e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8851675e",
  null
  
)

export default component.exports